export enum MentorshipRequestStage {
  OPEN = "open",
  CLAIMED = "claimed", // claimed by a mentor
  CLOSED = "closed", // resolved by mentors
  RESOLVED = "resolved", //resolved by mentees
}
